import React, { useEffect, useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import ZoneService from "../../../services/Zone";
import SocieteAndUserService from "../../../services/societeAndUser";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import { useParams } from "react-router-dom";
import DeliveryNoteTable from "./DeliveryNoteTable";
import { useLocation } from "react-router-dom";
import SellingService from "../../../services/SellingService";
import PlanningTable from "./PlanningTable";
import withLoader from "../../../components/layouts/WithLoader";
function filterByRole(data, roleName) {
  return data.filter(item =>
    item.role.some(role => role.name === roleName)
  );
}
const convertir = (data) => {
  if (Array.isArray(data)) {
    return data.map((user) => ({
      value: user.id,
      label: `${user.firstName.trim()} ${user.lastName.trim()}`, // Combine name and surname
    }));
  }
  return []; // Return an empty array if the data structure is invalid or not an array
};

const PlaningZone = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const id = params.get("id"); // Get 'id' from the query params

  const [showElement, setShowElement] = useState(
    JSON.parse(localStorage.getItem("status"))
  );
  const [societeLabel, setSocieteLabel] = useState([]);
  const [commercial, setCommercial] = useState([]);

  const [userList, setUserList] = useState([]);
  const [data, setData] = useState({});
  const [commercialList, setCommercialList] = useState([]);
  const [idCommerial, srtIdCommerial] = useState(null);
  const [idTranspoteur, srtIdTranspoteur] = useState(id);
  const [dateDebut, setDateDebut] = useState("any");
  const [dateFin, setDateFin] = useState("any");
  const [dateSelected, setDateSelcted] = useState(new Date().toISOString().split('T')[0]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState("");
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  // const [display, setDisplay] = useState(false);

  const [successAlertText, setSuccessAlertText] = useState("");
  useEffect(() => {
    const fetchData = async (id) => {
      try {
        const response = await ZoneService.getZone(id);
        const TRANSPORTER = response.data.success.usersZone;
        const COMMERCIAL = response.data.success.usersZone;

        setUserList(convertir(TRANSPORTER))
        setCommercialList(convertir(COMMERCIAL))
      } catch (error) {
        console.error("Error fetching user partners:", error);
      }
    };
    if (id) {
      fetchData(id);
    }
  }, [id]);


  const handleMultiSelectChange = (selectedOptions) => {
    setSocieteLabel(selectedOptions);
    srtIdTranspoteur(selectedOptions.value)
  };
  const handleSelectChange = (selectedOptions) => {
    setCommercial(selectedOptions);
    srtIdCommerial(selectedOptions.value)

  };
  const handleSuccessClose = (event, reason) => {
    if (reason !== "clickaway") {
      setOpenSuccessAlert(false);
    }
  };

  const handleErrorClose = (event, reason) => {
    if (reason !== "clickaway") {
      setOpenErrorAlert(false);
    }
  };

  const onConfirmAddSocieteHandler = async () => {


    // Ensure `description` and `name` variables are defined
    if (!idTranspoteur || !idCommerial) {
      setErrorAlertText("Description and Name are required!");
      setOpenErrorAlert(true);
      return;
    }
    startLoading();
    // Call the API
    SellingService.getProductsPlanningBySociete(id, getCurrentUserId(), idTranspoteur, idCommerial, dateDebut, dateFin).then((response) => {
      setData(response.data)

    }).catch((error) => {
      setErrorAlertText("Failed" + error);
      setOpenErrorAlert(true);
    }).finally(() => {
      stopLoading();
    })
    // setOpenSuccessAlert(true);
    // setSuccessAlertText("Zone added successfully!");
    // setDisplay(true)
    // navigate("/zone")

  };


  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">Home</li>
                <li className="breadcrumb-item ">Zone</li>
                <li className="breadcrumb-item active">Planing </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title">Planing</h5>
                </div>
                <div className="card-body">
                  <div className="row" style={{ marginTop: 10 }}>
                    {!showElement?.includes("USER_B2B") && (
                      <>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Date Debut:</label>
                            <input
                              className="form-control"
                              type="date"
                              value={dateDebut}
                              onChange={(e) => setDateDebut(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Date Fin:</label>
                            <input
                              className="form-control"
                              type="date"
                              value={dateFin}
                              onChange={(e) => setDateFin(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Choisir un transporteur:</label>
                            <Select
                              // isMulti
                              options={userList}
                              value={societeLabel}
                              onChange={handleMultiSelectChange}
                              className="basic-multi-select"
                              classNamePrefix="select"
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label for="commercial">Choisir un Commercial:</label>
                            <Select
                              // isMulti
                              options={commercialList}
                              value={commercial}
                              onChange={handleSelectChange}
                              className="basic-multi-select"
                              classNamePrefix="select"
                            />
                          </div>
                        </div>

                      </>
                    )}
                  </div>
                </div>
                <div className="card-footer">
                  <button
                    className="btn btn-dark float-right"
                    onClick={onConfirmAddSocieteHandler}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {data && typeof data === 'object' && Object.keys(data).length > 0 && <PlanningTable data={data} />}
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleErrorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleErrorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default withLoader(PlaningZone);
